<div class="language-selector" [matMenuTriggerFor]="languageMenu" [matTooltip]="translationService.currentLanguageOption.name">
  <span class="language-code">{{ translationService.currentLanguage | uppercase }}</span>
  <mat-icon class="dropdown-icon">arrow_drop_down</mat-icon>
</div>

<mat-menu #languageMenu="matMenu" xPosition="before">
  @for (lang of translationService.supportedLanguages; track lang.code) {
    <button mat-menu-item (click)="selectLanguage(lang.code)" [class.active]="lang.code === translationService.currentLanguage">
      <span class="language-name">{{ lang.nativeName }}</span>
      @if (lang.code === translationService.currentLanguage) {
        <mat-icon class="check-icon">check</mat-icon>
      }
    </button>
  }
</mat-menu>
